import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'headline')

	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "vUYYDQtwm8",
				"width": 552.6281287246723,
				"height": 86.328125,
				"left": 227.66,
				"top": 140.18790226460072,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 66.33px;\"><span style=\"font-family: 阿里巴巴普惠体;\">项目背景解析</span></span></strong></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "text",
				"id": "Xi5pC84Pqu",
				"width": 101.6,
				"height": 60.8125,
				"left": 451.1,
				"top": 65.54,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333333",
				"content": "<p style=\"text-align: center;\"><strong><span style=\"font-size: 40.82px;\"><span style=\"font-family: 阿里巴巴普惠体;\"><span style=\"color: rgba(60,159,200,1);\">01</span></span></span></strong></p>",
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			}
		],
		background
	}
}